import { render, staticRenderFns } from "./MonthProduct.vue?vue&type=template&id=86c27cc6&scoped=true"
import script from "./MonthProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./MonthProduct.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86c27cc6",
  null
  
)

export default component.exports